import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import {
  faChartPie,
  faClone,
  faGraduationCap,
  faShapes,
  faSignOut,
  faUser,
  faWindowMaximize,
} from '@fortawesome/pro-solid-svg-icons';
import { BannerContainerComponent } from '@terminus-ui/banner';
import {
  NavComponent,
  NavData,
  NavPlatformData,
  NavProfileData,
  UserInfo,
} from '@terminus-ui/nav';
import { AuthService } from 'auth';
import { EnvService } from 'frontend-environment';
import { PlatformNavEnv } from '../../platform-nav.env';

@Component({
  selector: 'ts-page-with-nav',
  imports: [CommonModule, NavComponent, BannerContainerComponent],
  templateUrl: './page-with-nav.component.html',
  styleUrls: ['./page-with-nav.component.scss'],
})
export class PageWithNavComponent {
  env = inject<EnvService<PlatformNavEnv>>(EnvService);
  private authService = inject(AuthService, { optional: true })!;

  @Input()
  appName: string = '';

  @Input()
  navData: NavData | null;

  @Input()
  user: UserInfo | null | undefined;

  @Input()
  impersonatingUser = false;

  @Input()
  homeLink: string = '';

  @Input()
  navPlatformData: NavPlatformData = [
    {
      title: 'Account Engagement Hub',
      items: [
        {
          icon: faShapes,
          text: 'Data Studio',
          path: this.env.DATA_STUDIO_APP_URL,
          requireNotLimitedView: true,
        },
        {
          icon: faChartPie,
          text: 'Measurement Studio',
          path: this.env.MEASUREMENT_STUDIO_APP_URL,
          requireNotLimitedView: true,
        },
      ],
    },
    {
      title: 'Channels',
      items: [
        {
          icon: faClone,
          text: 'Ad Experiences',
          path: this.env.ADEX_APP_URL,
          requireAdexMarketer: true,
        },
        {
          icon: faWindowMaximize,
          text: 'Web Experiences',
          path: this.env.WEB_EXP_APP_URL,
          requireNotLimitedView: true,
        },
      ],
    },
  ];

  domain = this.env.APP_DOMAIN;

  subdomain = window.location.hostname.split('.')[0];
  home = this.subdomain.includes('next') ? 'home-next' : 'home';

  @Input() navProfileData: NavProfileData = [
    [
      {
        icon: faUser,
        text: 'Profile',
        path: `https://${this.home}.${this.domain}/profile`,
      },
    ],
    [
      {
        icon: faGraduationCap,
        text: 'Platform Academy',
        path: 'https://customer-academy.terminus.com/app',
      },
    ],
    [{ icon: faSignOut, text: 'Sign Out', path: '/logout' }],
  ];
}
